<app-list-table [dataComplete]="exportsComplete$ | async" [dataNotComplete]="exportsNotComplete$ | async"
    (viewClick)="viewClick($event)" (createClick)="createClick()" (downloadClick)="downloadClick($event)"
    (cancelExport)="cancelExport($event)" (resumeExport)="resumeExport($event)" (pauseExport)="pauseExport($event)"
    (copyExport)="copyExport($event)" (applyFilter)="_filter.next($event)">
</app-list-table>